import React from 'react'

const Challenge = () => {
  return (
    <div>
        <h1>Urban Vertical Garden</h1>
    </div>
  )
}

export default Challenge
